import { useAuth } from '../context/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import './Layout.css';

export default function Layout({ children }) {
  const { utente, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const menuStudio = [
    { path: '/', label: 'Dashboard' },
    { path: '/clienti', label: 'Clienti' },
    { path: '/lavoratori', label: 'Lavoratori' },
    { path: '/comunicazioni', label: 'Comunicazioni' },
    { path: '/email', label: 'Email/PEC' },
    { path: '/statistiche', label: 'Statistiche' },
  ];

  const menuCliente = [
    { path: '/', label: 'Dashboard' },
    { path: '/lavoratori', label: 'Lavoratori' },
    { path: '/comunicazioni', label: 'Comunicazioni' },
    { path: '/email', label: 'Email/PEC' },
  ];

  const menu = utente.ruolo === 'studio' ? menuStudio : menuCliente;

  return (
    <div className="layout">
      <header className="header">
        <div className="headerLeft" onClick={() => navigate('/')}>
          <img src="/logo_boldrin_white.svg" alt="Studio Boldrin" className="logo" />
          <span className="appName">Intermittenti</span>
        </div>
        <nav className="nav">
          {menu.map(m => (
            <button
              key={m.path}
              onClick={() => navigate(m.path)}
              className={`navBtn ${location.pathname === m.path ? 'navBtnActive' : ''}`}
            >
              {m.label}
            </button>
          ))}
        </nav>
        <div className="headerRight">
          <div className="utenteInfo">
            <span className="utenteNome">{utente.nome} {utente.cognome}</span>
            <span className="badge">{utente.ruolo === 'studio' ? 'Studio' : utente.ragione_sociale || 'Cliente'}</span>
          </div>
          <button onClick={logout} className="logoutBtn">Esci</button>
        </div>
      </header>
      <main className="main">{children}</main>
      <footer className="footer">
        <span>Studio Boldrin — Gestione H-R | Dottori Commercialisti - Revisori Legali - Avvocati</span>
      </footer>
    </div>
  );
}
